const AdminCrudLayout = ({header, children}) => (
  <section className={'max-w-full'}>
    {header && <div className={'p-0 lg:p-5'}>{header}</div>}
    {children && <div className={'p-0 lg:p-5'}>{children}</div>}
  </section>
);

export default AdminCrudLayout;
